import { render, staticRenderFns } from "./hair-types-texture.vue?vue&type=template&id=280f7050&"
import script from "./hair-types-texture.vue?vue&type=script&lang=js&"
export * from "./hair-types-texture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports